import { useEffect, useState } from 'react'

import NexiaStream from 'services/NexiaStream'
import Environment from 'helpers/environment'

const VALID_EVENT_TYPES = ['current_status', 'sys_config', 'alarms', 'sys_components', 'remote_config_session']

const useNexiaStream = (deviceId, eventType, reportCache, optedIn = true) => {
  const url = `${Environment.backendApiURL()}/stream/${eventType}/${deviceId}`
  const reportKey = `react_${deviceId}_${eventType}`

  const [eventData, setEventData] = useState(reportCache[reportKey] ? reportCache[reportKey] : null)

  useEffect(() => {
    const eventListenerCallback = (event) => {
      if (event.data) {
        const report = JSON.parse(event.data)

        reportCache[reportKey] = report
        setEventData(report)
      }
    }

    if (VALID_EVENT_TYPES.includes(eventType) && optedIn) {
      NexiaStream.instance().addEventListener(`${deviceId}_${eventType}`, eventListenerCallback)

      NexiaStream.instance().whenConnected(() =>
        NexiaStream.instance().subscribeTo(url)
      )
    } else if (!optedIn) {
      setEventData(null)
    } else {
      throw new Error('invalid event type')
    }

    return () => {
      NexiaStream.instance().removeEventListener(`${deviceId}_${eventType}`, eventListenerCallback)
    }
  }, [url, deviceId, eventType, optedIn]) // eslint-disable-line react-hooks/exhaustive-deps

  return { eventData }
}

export default useNexiaStream
